import React, {useState, useEffect} from "react";
import { useNavigate } from "react-router-dom";
import Menu from "../../../../components/layout/menu/index";
import { useModuleAdherence } from "../../../../hooks/userAdherence";
import formIcon from "../../../../assets/images/icons/surveys/form-surveys.svg"
import { getSurveysByUser } from "../../../../client/surveys";
import { useAuth } from "../../../../context/auth";
import ContentLoader from "react-content-loader";

export default function SurveyProvider() {
  const { user } = useAuth();
  const navigate = useNavigate();
  useModuleAdherence(11);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [surveys, setSurveys] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const getUserId = () => {
    return user?.id || user?.userId;
  };

  const fetchUserSurveys = async () => {
    try {
      setLoading(true);
      const userId = getUserId();
      
      if (!userId) {
        setError("Usuario no identificado");
        return;
      }

      const response = await getSurveysByUser(userId);
      
      if (response.data && response.data.surveys) {
        setSurveys(response.data.surveys);
      } else {
        setSurveys([]);
      }
    } catch (err) {
      console.error("Error al cargar encuestas:", err);
      setError("Error al cargar las encuestas");
    } finally {
      setLoading(false);
    }
  };

  const handleSurveyClick = (surveyId) => {
    navigate(`/completar-encuesta/${surveyId}`);
  };

  useEffect(() => {
    fetchUserSurveys();
  }, []);

  const SurveyLoader = () => (
    <ContentLoader 
      speed={2}
      width={120}
      height={140}
      viewBox="0 0 120 140"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      className="flex flex-col items-center justify-center"
    >
      <rect x="20" y="10" rx="8" ry="8" width="80" height="80" />
      <rect x="10" y="100" rx="3" ry="3" width="100" height="12" />
      <rect x="20" y="118" rx="3" ry="3" width="80" height="10" />
    </ContentLoader>
  );

  return (
    <div>
      <Menu isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
        <div className={`flex-1 pt-[67px] transition-all duration-300 ${isMenuOpen ? "xl:pl-[20.7%] lg:pl-[23.7%] pl-0" : "pl-0"} bg-[#F7F8F9] w-full z-50 min-h-screen`}>
            <div className="sm:pt-8 pt-5 pb-10 sm:px-[3%] px-[5%] flex flex-col gap-6">
              <h1 className="text-blue font-itcbold text-2xl md:text-[32px]">
                Tus encuestas disponibles
              </h1>

              {loading ? (
                <div className="grid items-start grid-cols-2 gap-10 pt-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
                  {[...Array(10)].map((_, index) => (
                    <SurveyLoader key={index} />
                  ))}
                </div>
              ) :
              surveys.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-28">
                  <p className="text-[#6B7280] font-itcbook text-center text-xl">
                    No tienes encuestas asignadas en este momento.
                  </p>
                </div>
              ) : (
                  <div className="grid items-start grid-cols-2 gap-10 pt-4 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-5">
                  {surveys.map((survey) => (
                    <button 
                      key={survey.id} 
                      onClick={() => handleSurveyClick(survey.id)}
                      className="flex flex-col items-center justify-center"
                    >
                      <img src={formIcon} alt={survey.title}  />
                      <p className="text-[#6B7280] font-itcbook text-center text-xl">
                        {survey.title}
                      </p>
                      {survey.responsesCount > 0 && (
                      <p className="text-xs text-blue font-itcbold">
                        {survey.responsesCount} respuesta(s) enviada(s)
                      </p>
                      )}

                    </button>
                  ))}
                </div>
              )}
            </div>
        </div>
    </div>
  );
}